(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.onResizeHandler = this.updateHeaderMetrics.bind(this);
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

      this.updateHeaderMetrics();
      this.mobileMediaQuery.addEventListener('change', this.onResizeHandler);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrolledPastHeader = false;
      this.enterScrollThreshold = 8;
      this.exitScrollThreshold = 2;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updateHeaderMetrics() {
      this.setHeaderHeight();

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerRect = this.header.getBoundingClientRect();

      this.headerBounds = {
        top: headerRect.top + scrollTop,
        bottom: headerRect.bottom + scrollTop,
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.mobileMediaQuery.removeEventListener('change', this.onResizeHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const mobileScrolledTrigger = 12;
      const mobileResetTrigger = 4;
      const pastHeaderThreshold = this.mobileMediaQuery.matches
        ? mobileScrolledTrigger
        : this.headerBounds.bottom + this.enterScrollThreshold;
      const resetThreshold = this.mobileMediaQuery.matches
        ? mobileResetTrigger
        : this.headerBounds.top + this.exitScrollThreshold;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > pastHeaderThreshold) {
        if (!this.scrolledPastHeader) {
          this.header.classList.add('scrolled-past-header');
          this.scrolledPastHeader = true;
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > pastHeaderThreshold) {
        if (!this.scrolledPastHeader) {
          this.header.classList.add('scrolled-past-header');
          this.scrolledPastHeader = true;
        }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= resetThreshold) {
        if (this.scrolledPastHeader) {
          this.header.classList.remove('scrolled-past-header');
          this.scrolledPastHeader = false;
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons-with-text-pdp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let iconTextSwiper;

    function initSwiper() {
      if (window.innerWidth <= 767 && !iconTextSwiper) {
        iconTextSwiper = new Swiper('.icon-with-text-nested-main', {
          slidesPerView: 1.5,
          spaceBetween: 30,
          loop: false,
          centeredSlides: true,
          centeredSlidesBounds: true,
          initialSlide: 1,
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
            draggable: true,
          },
        });
      } else if (window.innerWidth > 767 && iconTextSwiper) {
        iconTextSwiper.destroy(true, true);
        iconTextSwiper = null;
      }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-product-promise"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let productPromiseSwiper;

    function initSwiper() {
      if (window.innerWidth <= 767 && !productPromiseSwiper) {
        productPromiseSwiper = new Swiper('.product-promise__items', {
          slidesPerView: 1.5,
          spaceBetween: 28,
          loop: false,
          centeredSlides: true,
          centeredSlidesBounds: true,
          initialSlide: 1,
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
            draggable: true,
          },
        });
      } else if (window.innerWidth > 767 && productPromiseSwiper) {
        productPromiseSwiper.destroy(true, true);
        productPromiseSwiper = null;
      }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
  });

  } catch(e) { console.error(e); }
})();
})();
